import { render, staticRenderFns } from "./PolicyImportAction.vue?vue&type=template&id=f498cfb0"
import script from "./PolicyImportAction.vue?vue&type=script&lang=js"
export * from "./PolicyImportAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports